module.exports = __webpack_public_path__ + "img/robot@2x.2cf9f129.png";